import React from 'react';
import { ZapIcon, CrownIcon, TargetIcon } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    icon: <ZapIcon className="w-8 h-8 text-gold" data-id="element-116" />,
    title: 'Carga Ultra-Rápida',
    description: 'Sitios web optimizados que cargan en menos de 2 segundos. La velocidad es dinero, y nosotros no perdemos ni un centavo.'
  }, {
    icon: <CrownIcon className="w-8 h-8 text-gold" data-id="element-117" />,
    title: 'Diseño de Autoridad',
    description: 'Diseño visual que posiciona tu marca como líder indiscutible de tu industria. Sin plantillas. Sin compromisos.'
  }, {
    icon: <TargetIcon className="w-8 h-8 text-gold" data-id="element-118" />,
    title: 'Sistemas de Conversión',
    description: 'Arquitectura digital diseñada para convertir visitantes en clientes de alto valor. Cada pixel tiene un propósito.'
  }];
  return <section className="py-24 px-4 bg-dark-900 relative" data-id="element-119">
      <div className="max-w-7xl mx-auto" data-id="element-120">
        <div className="text-center mb-16" data-id="element-121">
          <h2 className="font-serif text-3xl md:text-5xl text-white mb-4" data-id="element-122">
            Nuestros Servicios
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto rounded-full" data-id="element-123"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-124">
          {services.map((service, index) => <div key={index} className="bg-dark-800 border-t-2 border-gold/50 border-x border-b border-x-gold/10 border-b-gold/10 p-8 rounded-sm transition-all duration-300 hover:-translate-y-2 hover:border-gold hover:shadow-[0_0_30px_rgba(212,175,55,0.15)] group" data-id="element-125">
              <div className="mb-6 p-4 bg-dark-700 inline-block rounded-full border border-gold/20 group-hover:border-gold/50 transition-colors" data-id="element-126">
                {service.icon}
              </div>
              <h3 className="font-serif text-2xl text-white mb-4" data-id="element-127">
                {service.title}
              </h3>
              <p className="font-sans text-gray-400 leading-relaxed" data-id="element-128">
                {service.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}